import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { Commands } from "../core/util/commandManager";
import { ReportingHelper } from "../core/util/reportingHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Statistic, StatisticField } from "../core/components/statistic";
import React from "react"
import axios from "axios";

export class EditReportApp extends React.Component<EditReportAppProps, any> {
    common = new AppHelper();
    translations = {};
    private _dataLoaded = false;
    private _reportingHelper = ReportingHelper.create();
    private _questionsRegion = {
        title: "Questions",
        visible: true,
        fields: []
    }
    private _treeDataSource: Array<any>;
    private _cacheData = {
        serviceReportId: null,
        reportId: null,
        pIndex: null,
        recordId: null,
        position: null,
        type: null,
        machine: null,
        multiSelects: [],
        multiCheckBoxes: [],
        multiRadioButtons: [],
        floats: [],
        dropDownLists: [],
        originalDS: {},
        entity: {},
        mandant: null,
        remark: null
    };
    private _answerSelectRules = {};


    constructor(props) {
        super(props);
        this._initApp();
    }


    private _setDataSourceValues(fullDataSource, newValuesArray) {
        const newDS = [];
        for (let i = 0; i < fullDataSource.length; i++) {
            if (!newValuesArray || newValuesArray.indexOf(fullDataSource[i].value) >= 0) {
                newDS.push({
                    text: fullDataSource[i].text,
                    value: fullDataSource[i].value
                });
            }
        }
        return newDS;
    }

    private _isEmpty = (id): boolean => {
        if (!Helper.hasValue(this.props.entity["q" + id]) || this.props.entity["q" + id] === ""
            || (Array.isArray(this.props.entity["q" + id]) && this.props.entity["q" + id].length === 0)) {
            return true;
        } else {
            return false;
        }
    }

    private _setAnswerStatusMarker = (treeData: Array<any>) => {
        if (Array.isArray(treeData)) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].items.length > 0) {
                    this._setAnswerStatusMarker(treeData[i].items);
                    treeData[i].empty = treeData[i].items.map(c => { return c.empty ? 1 : 0 }).reduce((a, b) => { return a + b; }, 0) > 0;
                    if (treeData[i].qType >= 0) {
                        treeData[i].empty = treeData[i].empty || this._isEmpty(treeData[i].id);
                    }
                } else {
                    treeData[i].empty = this._isEmpty(treeData[i].id);
                }
            }
        }
    }


    save = async (closeAfterSave) => {
        return await this.ExecuteSave(closeAfterSave);
    }

    releaseDocument = async () => {
        await this.save(false);
        const markAsCompleted = await DialogHelper.confirm(this.translations["WebSMS.Reporting.ShouldReleaseReport"]);
        if (markAsCompleted) {
            await this.ExecuteSave(false, true);
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!Helper.hasValue(field)) {
            this.forceUpdate();
        }
        if (Helper.hasValue(this._answerSelectRules[field.model])) {
            const targetRule = this._answerSelectRules[field.model];
            //rollback the original data source
            for (var t = 0; t < targetRule.tQuestionIds.length; t++) {
                const ds = this._setDataSourceValues(this._cacheData.originalDS["q" + targetRule.tQuestionIds[t] + "_ds"], null);
                Helper.setArrayValues(this.props.dataSources["q" + targetRule.tQuestionIds[t] + "_ds"], ds);
                if (this._dataLoaded && this._cacheData.dropDownLists.indexOf("entity.q" + targetRule.tQuestionIds[t]) !== -1) {
                    this.common.commandManager.runCommand("entity.q" + targetRule.tQuestionIds[t], Commands.RELOADDATASOURCE);
                }
            }
            //update the data sources of the targeted questions
            //(questions which are specifically targeted by the current value)
            for (let targetQId in targetRule.sourceValueLookup[value]) {
                const propertyName = "q" + targetQId, entityPropName = "entity.q" + targetQId;
                const ds = this._setDataSourceValues(this._cacheData.originalDS[propertyName + "_ds"], targetRule.sourceValueLookup[value][targetQId]);
                Helper.setArrayValues(this.props.dataSources[propertyName + "_ds"], ds);
                if (this._dataLoaded && this._cacheData.dropDownLists.indexOf(entityPropName) !== -1) {
                    this.common.commandManager.runCommand(entityPropName, Commands.RELOADDATASOURCE);
                }
                //check if the current value is allowed (i.e. found in the data source)
                if (this._cacheData.multiSelects.indexOf(entityPropName) !== -1 || this._cacheData.multiCheckBoxes.indexOf(entityPropName) !== -1) {
                    //the case when the model is an array
                    if (Array.isArray(this.props.entity[propertyName])) {
                        const newVal = [];
                        for (let i = 0; i < this.props.entity[propertyName].length; i++) {
                            if (targetRule.sourceValueLookup[value][targetQId].indexOf(this.props.entity[propertyName][i]) !== -1) {
                                newVal.push(this.props.entity[propertyName][i]);
                            }
                        }
                        this.props.entity[propertyName] = newVal;
                    }
                } else {
                    //the model is not an array.
                    //if not in the data source, set to null
                    if (targetRule.sourceValueLookup[value][targetQId].indexOf(this.props.entity[propertyName]) === -1) {
                        this.props.entity[propertyName] = null;
                    }
                }
            }
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    showDocument = () => {
        Helper.openInNewBrowserTab(Config.baseUrl + "Reporting/ExportToPdf?servicereportId=" + this.props.context.keyVal1)
    }

    canRelease = () => {
        return this.props.entity.RecordRight.CanWrite;
    }

    expandAll = () => {
        this.collapseExpandAll(false);
    }

    collapseAll = () => {
        this.collapseExpandAll(true);
    }

    isPrintVisible = () => {
        return Config.settings.isFieldServiceDB && !this.props.entity.IsNew;
    }

    print = async () => {
        const titleApi = this.getObjectByName(this.props.metadata.additional.objects, "reportTitleDynamicApiId");
        let titleParameter = null;
        if (titleApi && titleApi.dynamicApiId) {
            const url = `${Config.baseUrl}Statistic/api/DynamicApi/${titleApi.dynamicApiId}/GetData?reportId=${this.props.context.serviceReportId}`;
            const result = await axios.get(url);
            if (result.data && result.data[0] && typeof result.data[0]['TITLE'] == "string") {
                titleParameter = `||Title=${result.data[0]['TITLE']}||`;
            }
        }
        const openUprintUrl = `innocruprint:FSMSTART=1 ||loginpassword=200068242168008171128061016140244007009067129071248199205081218034123184191146002002237177||  ||loginname=${Config.user.userName}|| ||previev_print=preview|| ||parameter1=${this.props.context.parentIsguid}|||${this.props.context.keyVal1}|| ||aufrufart=AF|| ||source=MA|| ${titleParameter ? titleParameter : ''}`;
        window.open(openUprintUrl, '_self');
    }

    private getObjectByName = (objectArray: any[], name: string): any => {
        const filtered = objectArray.filter((value) => value.name == name);
        if (filtered != null && filtered.length) {
            return filtered[0].data;
        }
    }

    collapseExpandAll = (collapse: boolean) => {
        if (!this.props.description.Sections) {
            return;
        }

        for (const s of this.props.description.Sections) {
            s._isCollapsed = collapse;
        }
        this.forceUpdate();
    }

    private openSheet = (reactComponent, props, title: string): Promise<boolean> => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.setTitle(title);
            sheet.mountContent(reactComponent, props);
        });
        return new Promise<boolean>((resolve, reject) => {
            sheet.bind(SheetEventType.Close, (data: any) => {
                resolve(true);
            });
        });
    }

    private setFields = (newData) => {
        $.extend(this.props.entity, newData);
        this.forceUpdate();
    }

    private getAPI = () => {
        return {
            baseUrl: Config.baseUrl,
            releaseDocument: this.releaseDocument,
            openSheet: this.openSheet,
            getReportId: () => { return this.props.context.keyVal1 },
            getMachine: () => { return this.props.context.machine },
            save: this.save,
            answers: null,
            canWrite: this.props.entity.RecordRight.CanWrite,
            dialog: DialogHelper,
            setFields: this.setFields
        };
    }

    private _initApp = () => {
        if (Helper.hasValue(this.props.description)) {
            Helper.getTranslations(["Standard.Msg.Loeschen", "Standard.Msg.SpeichernFehler", "Standard.Msg.SpeichernErfolgreich", "Standard.OK", "Standard.Neu",
                "Standard.Speichern", "Standard.CloseBtn", "Standard.BitteWählen", "Standard.Editieren", "Standard.Loeschen", "WebSMS.Reporting.AddReport", "WebSMS.Reporting.EditReport", "Maschine.Maschine", "WebSMS.Reporting.Questions", "WebSMS.Reporting.ShouldReleaseReport"])
                .then((result) => {
                    for (let key in result.Data) {
                        this.translations[key] = result.Data[key];
                    }

                    const tmpMeta = this._reportingHelper.createMetaData(this.props.description.Sections, this.props.description.DefaultTranslations, this._questionsRegion.fields, this.props.entity, false, null, this.props.context.keyVal1, this.getAPI(), this.props.description.JavaScriptFunctions);
                    for (let i = 0; i < tmpMeta.dataSources.length; i++) {
                        this.props.dataSources[tmpMeta.dataSources[i].name] = tmpMeta.dataSources[i].data;
                        this._cacheData.originalDS[tmpMeta.dataSources[i].name] = JSON.parse(JSON.stringify(tmpMeta.dataSources[i].data));
                    }

                    for (let i = 0; i < tmpMeta.flat.length; i++) {
                        if (this.props.entity.RecordRight.CanWrite !== true || this.props.entity.RecordRight.CanRead !== true) {
                            tmpMeta.flat[i].readOnly = true;
                        } else {
                            let value = null;
                            if (tmpMeta.flat[i].type === "kendo-multi-select" || tmpMeta.flat[i].type === "is-multiple-check-boxes") {
                                value = [];
                            }
                            this.props.entity[tmpMeta.flat[i].model.split(".")[1]] = value;
                        }
                    }

                    this._treeDataSource = tmpMeta.treeMeta;
                    this.common.init(this, {
                        tabs: [
                            {
                                title: this.props.metadata.tabs[0]["title"],
                                regions: this._questionsRegion.fields
                            }
                        ]
                    });
                    this._cacheData.reportId = this.props.context.reportId;
                    this._cacheData.pIndex = this.props.context.pIndex;
                    this._cacheData.recordId = this.props.context.recordId;
                    this._cacheData.serviceReportId = this.props.context.serviceReportId;
                    this._cacheData.position = this.props.context.position;
                    this._cacheData.type = this.props.context.type;
                    this._cacheData.machine = this.props.context.machine;
                    this._cacheData.entity = this.props.entity;
                    this._cacheData.mandant = this.props.mandant;
                    this._cacheData.remark = this.props.context.remark;

                    this._cacheData.dropDownLists = tmpMeta.dropDownLists;
                    this._cacheData.floats = tmpMeta.floats;
                    this._cacheData.multiCheckBoxes = tmpMeta.multipleCheckBoxes;
                    this._cacheData.multiRadioButtons = tmpMeta.multipleRadioButtons;
                    this._cacheData.multiSelects = tmpMeta.multiSelects;

                    if (this.props.data) {
                        this._reportingHelper.mapData(this.props.entity, this.props.data, this._cacheData);
                    }

                    if (Array.isArray(this.props.description.AnswerRules)) {
                        this._answerSelectRules = this._reportingHelper.setUpSelectAnswerRules(this.props.description.AnswerRules);
                    }

                    if (this._cacheData.position) {
                        const exclude = ["isnew", "recordright", "machine"];
                        for (let key in this._cacheData.entity) {
                            if (exclude.indexOf(key.toLowerCase()) === -1) {
                                this.handleFieldChange({ model: "entity." + key }, this._cacheData.entity[key], true);
                            }
                        }
                    }
                    if (this.props.entity.RecordRight.CanWrite) {
                        this.common.setEntityDirtyState(false);
                    }

                    this._dataLoaded = true;
                    this.setState({});
                });
        }
    }

    private ExecuteSave = async (closeAfterSave: any, released: boolean = false) => {
        if (this.props.entity.RecordRight.CanWrite === true && this.common.validate()) {
            const converted = this._reportingHelper.convertEntity(this._cacheData);
            let saveUrl = 'Reporting/' + (converted.ReportIndex && !this.props.context.plannedReportId ? "Update" : "Add") + '?';
            const params: any = {
                mandant: this._cacheData.mandant,
                released: released
            }
            if (this.props.context.plannedReportId) {
                params.plannedReportId = this.props.context.plannedReportId;
            }
            saveUrl += $.param(params);

            const result = await HTTPService
                .post<JsonResultClass>(saveUrl, converted);

            if (result.Code === 0) {
                if (this.props.entity.IsNew)
                    this.props.entity["serviceReportId"] = result.Data.ServiceReportId;
                this.props.entity.IsNew = false;
                if (result && result.Data) {
                    this._cacheData.position = result.Data.Index;
                    this._cacheData.serviceReportId = result.Data.ServiceReportId;
                    // TODO - das müssen wir auch für RecurringTasks machen, damit man die Dokumente dran hängen kann.
                    this.props.context.keyVal1 = result.Data.ServiceReportId;
                }
                NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
                if (released == true) {
                    this.props.entity.RecordRight.CanWrite = false;
                    this.forceUpdate();
                }
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);

        }
    }

    handleEval = (toEval: string) => {
        const result = new Function("entity", `return ${toEval}`)(this.props.entity);
        return result;
    }

    renderHeaderStatistic = () => {
        const headerStatistic = this.props.metadata.additional.objects.find(o => o.name == "headerStatistic");
        if (headerStatistic) {
            return <Statistic field={headerStatistic.data as StatisticField} value={null} context={null} disabled={false} handleEval={this.handleEval} />
        }
        return null;
    }

    private renderCompletionInfo(counts: { visibleQuestionCount: number; answeredQuestionCount: number; }) {
        const completionInfoSettings = this.props.metadata.additional.objects.find(o => o.name == "completionInfo");
        if (completionInfoSettings?.data?.enabled) {
            return <CompletitionInfo counts={counts}></CompletitionInfo>
        }
        return null;
    }

    render() {
        const fields = [];
        const tmpMeta = this._reportingHelper.createMetaData(this.props.description?.Sections, this.props.description?.DefaultTranslations, fields, this.props.entity, false, null, this.props.context.keyVal1, this.getAPI(), this.props.description?.JavaScriptFunctions);
        for (let i = 0; i < tmpMeta.dataSources.length; i++) {
            this.props.dataSources[tmpMeta.dataSources[i].name] = tmpMeta.dataSources[i].data;
            this._cacheData.originalDS[tmpMeta.dataSources[i].name] = JSON.parse(JSON.stringify(tmpMeta.dataSources[i].data));
        }
        const counts = tmpMeta.counts;

        if (this._dataLoaded) {
            this._setAnswerStatusMarker(this._treeDataSource);
            const props = $.extend({},
                this.props,
                this.common.getHandlersForProps(),
                {
                    handleFieldChange: this.handleFieldChange,
                    context:
                    {
                        questionsRegion: fields,
                        treeDataSource: this._treeDataSource,
                        key1: this.props.context.key1,
                        keyVal1: this.props.context.keyVal1,
                        contextType: this.props.context.contextType
                    }
                });
            const headerStatistic = this.renderHeaderStatistic();
            const countsComponent = this.renderCompletionInfo(counts);
            return <div style={{ display: "flex", flexDirection: "column", height: "100%", flex: "1" }}>{headerStatistic}{countsComponent}<CommonApp {...props} /> </div>;
        } else {
            return null;
        }
    }
};

class CompletitionInfo extends React.Component<{ counts: { answeredQuestionCount: number, visibleQuestionCount: number } }, any> {

    render() {
        const percent = Math.round((100 / this.props.counts.visibleQuestionCount * this.props.counts.answeredQuestionCount));
        return <div style={{ marginTop: "10px", marginLeft: "10px", marginRight: "10px", border: "1px solid", textAlign: "center", background: `linear-gradient(to right,  lightgreen 0%,lightgreen ${percent}%,red ${percent}%,red 100%)` }}>{this.props.counts.answeredQuestionCount + "/" + this.props.counts.visibleQuestionCount} ({percent}%)</div>;
    }
}

export interface EditReportAppProps extends AppBaseProps {
    context: EditReportContext;
    description: {
        AnswerRules: Array<any>;
        Sections: Array<any>;
        DefaultTranslations: string[];
        JavaScriptFunctions
    };
    mandant: string;
    data: any;
}

interface EditReportContext extends Context {
    machine: string;
    type: number;
    reportId: number;
    serviceReportId: string;
    position: number;
    recordId: string;
    pIndex: number;
    contextType?: string;
    keyVal1?: string;
    plannedReportId?: string;
    parentIsguid?: string;
    remark?: string;
}